import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';

const NotesWrapper = styled.div`
    position: relative;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    height: 100%;
    ${props => props.$open ? `z-index: 101;` : ''}
`;

const NotesContainer = styled.div`
    padding: 0.5rem 0;
    display: flex;
    flex-flow: wrap;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
    cursor: ${props => props.$expandable ? 'pointer' : 'default'};
`;

const NotesExpanded = styled.div`
    position: absolute;
    left: 0;
    top: 0.35rem;
    z-index: 101;
    min-width: 100%;
    min-height: calc(100% - 0.35rem);
    width: max-content;
    max-width: min(36rem, 70vw);
    padding: 0.5rem;
    display: flex;
    flex-flow: wrap;
    align-items: flex-start;
    justify-content: flex-start;
    background: var(--bg);
    box-shadow: var(--on-hover-visible-object-shadow);
    border-radius: 0.5rem;
`;

export const NoteObject = styled.div`
    color:${props => props.$urgent ? "var(--alertTextColor)" : "var(--gray)" };
    font-weight:600;
    font-size:0.95rem;
    padding:${props => props.$customVerticalPadding ? props.$customVerticalPadding : "0.2rem" } 0.6rem ;
    margin: 0.0rem 0.25rem 0.4rem 0.25rem;
    border-radius:0.3rem;
    background:${props => props.$urgent ?  "var(--mainBoardAlertsBg)" : props.$customBackgroundColor ? props.$customBackgroundColor : "var(--extra-light-gray)"};
    white-space:${props => props.$fullText ? "normal" : "nowrap"};
    overflow:${props => props.$fullText ? "visible" : "hidden"};
    word-break:${props => props.$fullText ? "break-word" : "normal"};
    max-width:${props => props.$fullText ? "100%" : "none"};
    ${props => props.$customBorderColor ? `border: thin solid ${props.$customBorderColor};` : ''}
    

`;

const noteSnippet = (noteMessage) =>
    noteMessage.length > 27 ? noteMessage.substr(0, 26) + "..." : noteMessage;

const NotesList = ({ notes, fullText }) => notes.map((note, index) => (
    <NoteObject key={index} $urgent={note.urgent} $fullText={fullText}>
        {fullText ? note.noteMessage : noteSnippet(note.noteMessage)}
    </NoteObject>
));

export const MB_NOTES = ({ allNotes, truckId, popupViewManagingObject }) => {
    const [open, setOpen] = useState(false);
    const container = useRef(null);
    const relevantNotes = allNotes ? allNotes.filter((note) => note.relevant) : [];
    const expandable = relevantNotes.length > 0;

    useEffect(() => {
        const card = container.current?.closest('.TRUCK_CARD_CONTAINER');
        if (!card) return undefined;
        if (open) {
            card.style.zIndex = '50';
        } else {
            card.style.zIndex = '';
        }
        return () => {
            card.style.zIndex = '';
        };
    }, [open]);

    const handleOpen = (e) => {
        if (!expandable || open) return;
        e.stopPropagation();
        if (popupViewManagingObject) {
            popupViewManagingObject(`${truckId}-notes`, container, setOpen);
        }
        setOpen(true);
    };

    return (
        <NotesWrapper ref={container} $open={open}>
            <NotesContainer
                className="notesConteiner"
                $expandable={expandable}
                onClick={handleOpen}
            >
                <NotesList notes={relevantNotes} />
            </NotesContainer>
            {open ? (
                <NotesExpanded onClick={(e) => e.stopPropagation()}>
                    <NotesList notes={relevantNotes} fullText />
                </NotesExpanded>
            ) : null}
        </NotesWrapper>
    );
}
export const parseAndSortNotes = (truckCardData) => {
    const load = truckCardData.currentLoad; 
    const driver1 = truckCardData.driver1;
    const driver2 = truckCardData.driver2;
    const trailer = truckCardData.currentTrailer;
    
    let newArray = [];
    if(load && load.notes){
        Array.prototype.push.apply(newArray, parseAndModifyNotesArray(load.notes, 'loads', load.id));
    }
    if(truckCardData && truckCardData.notes){
        Array.prototype.push.apply(newArray, parseAndModifyNotesArray(truckCardData.notes, 'trucks', truckCardData.id));
    }
    if(driver1  && driver1.notes){
        Array.prototype.push.apply(newArray, parseAndModifyNotesArray(driver1.notes, 'drivers', driver1.id, `${driver1.firstName} ${driver1.lastName}`));
    }
    if(driver2  && driver2.notes){
        Array.prototype.push.apply(newArray, parseAndModifyNotesArray(driver2.notes, 'drivers', driver2.id, `${driver2.firstName} ${driver2.lastName}`));
    }
    if(trailer  && trailer.notes){
        Array.prototype.push.apply(newArray, parseAndModifyNotesArray(trailer.notes, 'trailers', trailer.id));
    }
    newArray.sort((a, b) => b.urgent - a.urgent);
    return newArray
}
const parseAndModifyNotesArray = (notes, type, id, label) => {
    const result = [];
    for(let i = 0; i < notes.length; i ++){
        const note = typeof notes[i] === 'object' ? notes[i] : JSON.parse(notes[i]);
        note.type = type;
        note.subjectId = id;
        note.label = label;
        result[i] = note;
    }
    return result;
}
